import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { Invoice } from '@/views/my-projects/components/invoices/fakeData';
import BCXUserBanner from '@/components/molecules/BCXUserBanner.vue';
import InvoiceIncomingExtendedRowButtonArea from '@/views/my-projects/components/invoices/InvoiceIncomingExtendedRowButtonArea.vue';
import IncoiceIncomingExtendedRowBaseData from '@/views/my-projects/components/invoices/InvoiceIncomingExtendedRowBaseData.vue';
import InvoiceAttachmentFileTable from '@/views/my-projects/components/invoice/attachments/InvoiceAttachmentFileTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceIncomingExtendedRow',
  props: {
  invoice: {
    type: Object as PropType<Invoice>,
    default: null
  }
},
  setup(__props) {



const files = [{
  date: '2023-01-01',
  name: 'invoice.pdf',
},
{
  date: '2021-05-03',
  name: 'invoice-2.pdf',
},
{
  date: '2021-01-05',
  name: 'invoice-addition-wrgwerg-werg-wetg-wetgw-erg-werg-wergw-erg-werg-wergwerg-wergw-erg.pdf',
}
];

return { __sfc: true,files, BCXUserBanner, InvoiceIncomingExtendedRowButtonArea, IncoiceIncomingExtendedRowBaseData, InvoiceAttachmentFileTable }
}

})